import { IoIosClose } from 'react-icons/io'
import { Component, Delete } from './style'
const ComponentItem = ({
  title,
  quantidade,
  unidade,
  height,
  padding,
  id,
  size,
  deleteComponent,
  invert,
  margin,
}) => {
  return (
    <Component
      type="button"
      size={size}
      margin={margin}
      invert={invert}
      height={height}
      padding={padding}
    >
      {deleteComponent && (
        <Delete onClick={() => deleteComponent(id)}>
          <IoIosClose />
        </Delete>
      )}
      <span>
        {title} {quantidade} {unidade}{' '}
      </span>
    </Component>
  )
}
export default ComponentItem
